<template>
  <div class="modal-popup">
    <div class="modal fade" id="showUseCouponPopUp" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="title mb-2 ml-3">Kupon Kullanma</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
            <div class="modal-body">
              <div class="contact-form-action">
                <div class="col-lg-12">
                  <div class="card-item p-3">
                    <div class="row" >
                      <div class="contact-form-action col-sm-6">
                        <base-edit-input
                            v-model="reservationNumber"
                            :rules="'required'"
                            :type="'text'"
                            :label="'Rezervasyon Numarası'">
                        </base-edit-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="contact-form-action ml-4">
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Geri</button>
            <button @click="useCoupon()" type="button" class="theme-btn theme-btn-small" style="background-color: RED;color: WHITE;">Kuponu Kullan</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BaseEditInput from "../base/BaseEditInput";
import messagePopupManager from "../../util/messagePopupManager";
export default {
  name: "UseCouponPopup",
  components: {BaseEditInput},
  data:function (){
    return{
      reservationNumber: "",
    }
  },
  methods:{
    useCoupon(){
      let useCouponRequest = {};
      useCouponRequest.bookingNumber = this.reservationNumber;
      useCouponRequest.couponId = this.$store.getters.getCouponId;

      this.$store.dispatch("useCoupon", useCouponRequest).then(response => {
        messagePopupManager.showSuccess()
        $("#useCouponPopup").modal("hide");
      })
    },
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>

</style>